import { db } from '@/config/firebase'
import { collection, addDoc, Timestamp, query, where, getDocs, doc, getDoc } from 'firebase/firestore'
import { NotificationType } from '@/types/notification'

export const notificationService = {
    async create(
        userId: string,
        orgId: string,
        type: NotificationType,
        title: string,
        message: string,
        actionUrl?: string,
        metadata?: Record<string, any>
    ) {
        await addDoc(collection(db, 'users', userId, 'notifications'), {
            userId,
            orgId,
            type,
            title,
            message,
            read: false,
            actionUrl: actionUrl || null,
            createdAt: Timestamp.now(),
            metadata: metadata || null
        })
    },

    async notifyAdmins(orgId: string, title: string, message: string, actionUrl?: string) {
        try {
            // 1. Buscar membros admins/owners
            const q = query(
                collection(db, 'members'),
                where('orgId', '==', orgId),
                where('role', 'in', ['admin', 'owner'])
            )
            const snapshot = await getDocs(q)
            const adminIds = new Set(snapshot.docs.map(d => d.data().userId))

            // 2. Buscar dono da organização (caso não esteja no members)
            const orgRef = doc(db, 'organizations', orgId)
            const orgSnap = await getDoc(orgRef)

            if (orgSnap.exists()) {
                const ownerId = orgSnap.data().ownerId
                if (ownerId) adminIds.add(ownerId)
            }

            // 3. Enviar
            const notifications = Array.from(adminIds).map(userId =>
                this.create(
                    userId,
                    orgId,
                    'new_booking_request',
                    title,
                    message,
                    actionUrl
                )
            )

            await Promise.all(notifications)

        } catch (error) {
            console.error('Error notifying admins:', error)
        }
    }
}
